import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Input, SubmitButton, SubTab, SubInput, RenderInputFields } from "../Form/Form";
import { createSlug } from "../../util/fn";
import { useSelector } from "react-redux";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();

  const { languages } = useSelector((state) => state.setting);

  const [previewImage, setPreviewImage] = useState("");

  const { response, request } = useRequest();

  const history = useHistory();

  useEffect(() => {
    document.title = "Add Brand";
  }, []);

  useEffect(() => {
    if (response) {
      toast.success("Brand added successfully.");
      history.push("/brands");
    }
  }, [response]);

  const onSubmit = (data) => {
    const dataToSend = [];
    const checkData = {
      label: "",
      value: "",
      langData: [],
    };

    let name;

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      dataToSend.push({
        languageCode: code,
        name: data["name-" + code] ?? "",
        slug: data["slug-" + code] ?? "",
      });

      if (languages[i].default) {
        name = data["name-" + code];
        checkData.label = name;
        checkData.value = name;
      }

      checkData.langData.push({
        languageCode: code,
        value: data["name-" + code] ?? "",
        slug: data["slug-" + code] ?? "",
      });
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("image", data.image[0]);
    formData.append("subData", JSON.stringify(dataToSend));

    request("POST", "brand", formData);
  };

  const displayImageHandler = (e) => {
    setPreviewImage(URL.createObjectURL(e.target.files[0]));
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "Image",
        type: "file",
        name: "image",
        registerFields: {
          required: false,
        },
        handleMedia: displayImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: previewImage && (
          <>
            <img
              src={previewImage}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
          </>
        ),
      },
    ],
  ];

  return (
    <div
      className={`content d-flex flex-column flex-column-fluid`}
      id="kt_content"
    >
        <Breadcrumb
          title="Add Brand"
          links={[
            { to: "/", name: "Dashboard" },
            { to: "/brands", name: "Back To Brands" },
          ]}
        />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
              <div className="card-header">
                <h3 className="card-title">Add New Brand</h3>
              </div>
      
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                    <RenderInputFields
                        InputFields={InputFields}
                        errors={errors}
                        register={register}
                      />
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                  tabName={`language_${index}`}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <SubInput
                                key={index}
                                index={index}
                                errors={errors}
                                register={register}
                                required={lang.required}
                                control={control}
                                code={lang.code}
                                tabName={`language_${index}`}
                                InputFields={[
                                  [
                                    {
                                      Component: Input,
                                      label: "Name",
                                      type: "text",
                                      name: "name",
                                      isRequired: true,
                                      colClass: " ",
                                      registerFields: {
                                        onBlur: (e) => {
                                          setValue(
                                            `slug-${lang.code}`,
                                            createSlug(e.target.value)
                                          );
                                        },
                                      },
                                    },
                                  ],
                                ]}
                              />
                            ))}
                        </div>
                      </div>
                    </div>

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                      pxClass="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
